// extracted by css-extract-rspack-plugin
export default {"root":"amLfy","titleButton":"Rm1L0","breadcrumbLink":"LQmFd"};